"use client";
import {
  CategoryStyleTypes,
  ICategories,
} from "@/api/AppApi/services/home/interfaces/ICategory";
import Category from "./Category";
import { WIDTHS } from "@/api/AppApi/common-interfaces/api-enums";
import { useIsMobile } from "@/hooks/useIsMobile";
import EmblaSlider from "../../lib/Embla-slider";
import { TSlideWidith } from "../../lib/Embla-slider/EmblaSliderContainer";
import useIsClient from "@/hooks/useIsClient";
interface Props extends ICategories {
  speed?: number;
  isSubCategory: boolean;
  showCategoryImage: boolean;
}
const itemWidth = (style_type: CategoryStyleTypes, mobile: boolean) => {
  switch (style_type) {
    case CategoryStyleTypes.circle_icon:
      return {
        width: !mobile
          ? WIDTHS.category.circle_icon_pc
          : WIDTHS.category.circle_icon,
        spacing: !mobile ? 12 : 20,
      };
    case CategoryStyleTypes.circle_img:
      return {
        width: !mobile
          ? WIDTHS.category.circle_img_pc
          : WIDTHS.category.circle_img,
        spacing: 20,
      };
    case CategoryStyleTypes.square:
      return { width: WIDTHS.category.square_large, spacing: 8 };
    case CategoryStyleTypes.square_primary_title:
      return {
        width: !mobile
          ? WIDTHS.category.square_colored_title_pc
          : WIDTHS.category.square_colored_title,
        spacing: 16,
      };
    default:
      return { width: 0, spacing: 0 };
  }
};

const CategoryCarousel: React.FC<Props> = (props) => {
  const isClient = useIsClient();
  const {
    advance_mode,
    width: slideWidth,
    width_mobile,
  } = props?.configurations?.customize ?? {};
  const advanceMode = isClient && advance_mode;
  const mobile = useIsMobile();
  const styleType =
    props.configurations?.style_type ?? CategoryStyleTypes.circle_icon;

  const { width, spacing } = itemWidth(styleType, mobile);
  const SlideWidth = advanceMode ? (mobile ? width_mobile : slideWidth) : width;

  const autoPlay = !!props.speed && props.speed > 0;
  if (!isClient)
    return (
      <div
        className={`skeleton-rect`}
        style={{
          width: "100%",
          paddingTop: `${96}px`,
        }}
      />
    );
  return (
    <EmblaSlider autoPlay={autoPlay} autoplayDuration={props.speed ?? 0}>
      <EmblaSlider.EmblaSliderViewport>
        <EmblaSlider.EmblaSliderContainer
          gap={spacing}
          slides={[
            ...props.data?.map((single) => ({
              component: (
                <div style={{ width: SlideWidth }}>
                  <Category
                    key={single.id}
                    categoryType={styleType}
                    customize={props?.configurations?.customize!}
                    showCategoryImage={props.showCategoryImage}
                    {...single}
                  />
                </div>
              ),
              width: "auto" as TSlideWidith,
            })),
          ]}
        />
        {/* <EmblaSlider.EmblaFilters /> */}
        <EmblaSlider.EmblaSliderPrevNextButtons />
      </EmblaSlider.EmblaSliderViewport>
    </EmblaSlider>
  );
};

export default CategoryCarousel;
